const t=(t,o="B",r=2)=>{if(0===t)return`0 ${o}`;if(!t)return"-";const a=r<0?0:r,e=["","K","M","G","T","P","E","Z","Y"].map((t=>t+o));let l=Math.floor(Math.log(t)/Math.log(1024));return 0===l&&l++,`${parseFloat((t/Math.pow(1024,l)).toFixed(a))} ${e[l]}`};export{t as formatBytes};
//# sourceMappingURL=formatBytes.js.map
